import { config, authHeader } from '../helpers'
import { handleHttpResponse } from '../helpers';

export const MeteringService = {
    addIndex,
    getMeteringsWPaging,
    getIndexes,
    deleteMetering,
    modifyIndex,
}

function addIndex(variableIDs, variableValues, date, type, source, podId, clientId) {
  const castedVariableValues = variableValues.map(value => Number(value));
  const query = `mutation{
      addIndex(variableIDs:${JSON.stringify(variableIDs)},
      variableValues: ${JSON.stringify(castedVariableValues)},
      date: ${JSON.stringify(date)},
      type: ${JSON.stringify(type)},
      source:${JSON.stringify(source)},
      clientID: ${JSON.stringify(clientId)},
      podID: ${JSON.stringify(podId)}
      ){
        id
        date,
        type,
        source,
        value
      }
    }`;
  const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/graphql', ...authHeader() },
      body: query
    }
  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.addIndex);
    })
}

// currently only used to get consumptions
function getMeteringsWPaging(timeframes, podId, cliId, index, number, getIndexes) {
  const query = `{meteringsWPaging(
    clientID: ${JSON.stringify(cliId)},
    podID: ${JSON.stringify(podId)},
    timeframes: ${JSON.stringify(timeframes)},
    index: ${index},
    number: ${number},
    getIndexes: ${getIndexes}){
      lastPage
      nbPages
      meterings{
          id
          date
          ${getIndexes ? `` : `dateFrom`}
          type
          source
          value
          transactionID
          variable{
            id
            name
            validTo
          }
      }
  }}`;
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  };
  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
    return handleHttpResponse(response)
    .then(data => {
        return data.meteringsWPaging;
    });
  })
}
// currently only used to get indexes
function getIndexes(variableIDs, podId, cliId, index, number, getIndexes) {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() }
  }

  const query = `indexList(
    clientID:${JSON.stringify(cliId)},
    podID: ${JSON.stringify(podId)},
    variablesIDs: ${JSON.stringify(variableIDs)},
    index: ${index},
    number: ${number},
    getIndexes: ${getIndexes}){
      lastPage
      nbPages
      variables {
        id
        name
        validFrom
      }
      index {
        date
        source
        transactionID
        meterings {
          id
          value
          variable {
            id
            name
          }
        }
      }
  }`;

  return fetch(`${config.apiUrl}/graphql?query={${query}}`, requestOptions)
  .then(response => {
    return handleHttpResponse(response).then(data => data.indexList);
  })
}

function deleteMetering(clientID, podID, transactionID) {
  const query = `mutation{
    deleteIndex(transactionID: ${JSON.stringify(transactionID)}, clientID: ${JSON.stringify(clientID)}, podID: ${JSON.stringify(podID)}){
      ID
    }
  }`;
  const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/graphql', ...authHeader() },
      body: query
  }
  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.deleteMetering);
  })
}

function modifyIndex(clientID, podID, transactionID, variableIDs, variableValues, date) {
  const castedVariableValues = variableValues.map(value => Number(value));
  const query = `mutation{
    modifyIndex(
      clientID: ${JSON.stringify(clientID)}
      podID: ${JSON.stringify(podID)}
      transactionID: ${JSON.stringify(transactionID)}
      variableIDs: ${JSON.stringify(variableIDs)}
      variableValues: ${JSON.stringify(castedVariableValues)}
      date: ${JSON.stringify(date)}
    ){
      ID
    }
  }`

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  }

  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
    return handleHttpResponse(response)
    .then(data => data.modifyIndex);
  })
}

// ajouter une méthode qui charge une liste d'index avec leurs dates pour la sélection des périodes de "facturation" (pour les pods créés par les users)
// utiliser le registre le plus ancien qui n'a pas encore de date de fin.
// function loadAllKnownConsumptionPeriods(clientID, podID) {
  
// }